/**
 * 模块名称：
 * @author ：XXXXX
 */
import { Toast } from 'vant';
import {
    changeStatus,
    candidateOrdersView,
    handleRecommnd,
    handleRecommendList,
    getOrderTalk,
    getOrderDetail,
    getQuestionList,
    getJReportInfo,
    replaceOfferDetail,
    getCandidateList,
    getReasonInfo
} from '@/api/receivingOrder.js'
import wxapi from '@/utils/wxapi.js';
import { transformCandidateData } from "@/utils/resusmeFilter";

const state = {
    recommendList: [],
    currentPosition: {},
    documentData: [], //候选人列表
    canChange: false,
    isReceive: 0,
    isFirst: false,
    talkList: [],
    talkCount: 0,
    orderDetail: '',
    questionList: [],
    JReportInfo: '',
    docCount: 0,
    candidateList: {},
    dataChange: false,
    reasonInfo: ''
}
const mutations = {
    /**
     * 为state项赋值
     * @param state
     * @param data
     */
    setStateItem(state, data) {
        state[data.key] = data.value
    },
    setcandidateList(state, data) {
        if (state.candidateList[data.id]) {
            state.candidateList[data.id].data.push(...data.data)
            state.candidateList[data.id].count = data.count
            state.candidateList[data.id].id = data.id
        } else {
            state.candidateList[data.id] = { data: [], count: 0, id: '' }
            state.candidateList[data.id].data.push(...data.data)
            state.candidateList[data.id].count = data.count
            state.candidateList[data.id].id = data.id
        }
        state.dataChange = true
    },
    tochangeIndex(state, data) {
        if (state.candidateList[data]) {
            delete state.candidateList[data]
        }
        state.dataChange = true
    }

}
const actions = {
    //更新候选人订单进度
    async changeStatus({ state, commit }, data) {
        try {

            const res = await changeStatus(data)
            if (res.data.code == 200) {
                data.cb && data.cb();

                // commit('setStateItem', { key: 'agreementInfo', value: res.data.data })
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    //查看并筛选
    async candidateOrdersView({ state, commit }, data) {
        try {
            const res = await candidateOrdersView(data)
            if (res.data.code == 200) {
                // commit('setStateItem', { key: 'agreementInfo', value: res.data.data })
                let parames = {
                    title: '上禾蛙hewa.cn，更多职位等你来',
                    dec: '猎头上禾蛙—简历不浪费，职位不白费'
                }
                wxapi(parames)
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    //查看当前职位详情
    async handleRecommnd({ state, commit }, data) {
        try {
            const res = await handleRecommnd(data)
            if (res.data.code == 200) {
                data.cb && data.cb();
                const result = transformCandidateData(res.data.data.documentData, 0);
                commit('setStateItem', { key: 'currentPosition', value: res.data.data.jobData })
                commit('setStateItem', { key: 'documentData', value: result })
                commit('setStateItem', { key: 'isReceive', value: res.data.data.is_receive })
                if (res.data.data.is_receive == 0) {
                    Toast("没有权限")
                }
                let parames = {
                    title: '上禾蛙hewa.cn，更多职位等你来',
                    dec: '猎头上禾蛙—简历不浪费，职位不白费'
                }
                wxapi(parames)
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    //微信处理简历列表
    async handleRecommendList({ state, commit }, data) {
        try {
            const res = await handleRecommendList(data)
            if (res.data.code == 200) {
                commit('setStateItem', { key: 'recommendList', value: res.data.data.job_list })
                commit('setStateItem', { key: 'docCount', value: res.data.data.count })
                commit('setStateItem', { key: 'isFirst', value: true })
                let parames = {
                    title: '上禾蛙hewa.cn，更多职位等你来',
                    dec: '猎头上禾蛙—简历不浪费，职位不白费'
                }
                wxapi(parames)
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    // 沟通记录
    async requestOrderTalk({ state, commit }, data) {
        try {
            const res = await getOrderTalk(data)
            if (res.data.code == 200) {
                commit('setStateItem', { key: 'talkList', value: res.data.data.record_list })
                commit('setStateItem', { key: 'talkCount', value: res.data.data.count })
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    // 候选人详情
    async requestOrderDetail({ state, commit }, data) {
        try {
            const res = await getOrderDetail(data)
            if (res.data.code == 200) {
                data.cb && data.cb();
                const result = transformCandidateData(res.data.data, 1);
                result[0].order_id = data.order_id;
                commit('setStateItem', { key: 'orderDetail', value: res.data.data })
                commit('setStateItem', { key: 'documentData', value: result })
                    // commit('setStateItem', { key: 'talkCount', value: res.data.data.count })
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    // 候选人必问问题
    async requestQuestionList({ state, commit }, data) {
        try {
            const res = await getQuestionList(data)
            if (res.data.code == 200) {
                data.cb && data.cb();
                commit('setStateItem', { key: 'questionList', value: res.data.data.question_list })

                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    // 候选人推荐报告
    async requestJReportInfo({ state, commit }, data) {
        try {
            const res = await getJReportInfo(data)
            if (res.data.code == 200) {
                data.cb && data.cb();
                commit('setStateItem', { key: 'JReportInfo', value: res.data.data.j_recommend_report_url })

                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    //催一下 queryCandidateOrderDetail
    async replaceOfferDetail({ state, commit }, data) {
        try {
            const res = await replaceOfferDetail(data)
            if (res && res.status === 200 && res.data.code === "200") {
                Toast('平台已通知接单方尽快处理，请耐心等待')
                    // window.location.reload()
                data.cb && data.cb();
                return true;
            } else {
                Toast(res.data.message)
                return false;
            }

        } catch (e) {

        }
    },
    /**
     * 候选人列表
     */
    async requestCandidateList({ state, commit }, data) {
        try {
            const res = await getCandidateList(data)
            if (res.data.code == 200) {
                let params = {
                    data: res.data.data.document_list,
                    count: res.data.data.count,
                    id: data.job_id,
                }

                // commit('setStateItem', { key: 'candidateList', value: res.data.data.document_list })
                // commit('setStateItem', { key: 'candidateCount', value: res.data.data.count })

                commit('setcandidateList', params)
                data.cb && data.cb();
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    // 获取候选人订单中止原因
    async requestReasonInfo({ state, commit }, data) {
        try {
            const res = await getReasonInfo(data)
            if (res.data.code == 200) {
                commit('setStateItem', { key: 'reasonInfo', value: res.data.data })

            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    initCandidate({ commit }, data) {
        commit('setStateItem', { key: 'dataChange', value: true })
        commit('setStateItem', { key: 'candidateList', value: {} })
    },
    // 候选人订单详情
    setCanChange({ commit }, data) {
        commit('setStateItem', { key: 'canChange', value: data })
    }
}
export default {
    state,
    actions,
    mutations,
    namespaced: true,
}